/**
 * LeaveProvisionsSection Component
 * Collapsible leave provisions breakdown within Compliance tab
 */

import { SectionCard } from './SectionCard';
import { formatCurrency } from '@/utils/formatters';
import type { ComplianceSnapshotResponse } from '@/api/complianceApi';

interface LeaveProvisionsSectionProps {
  leaveProvisions: ComplianceSnapshotResponse['data']['leaveProvisions'];
}

export function LeaveProvisionsSection({ leaveProvisions }: LeaveProvisionsSectionProps) {
  return (
    <SectionCard
      title="Leave Provisions"
      badge={
        <span className="compliance-dashboard__count">
          {formatCurrency(leaveProvisions.totalLeaveProvision)} total
        </span>
      }
    >
      <div className="compliance-dashboard__leave">
        <div className="compliance-dashboard__leave-summary">
          <div className="compliance-dashboard__leave-item">
            <span className="compliance-dashboard__leave-label">Annual Leave</span>
            <span className="compliance-dashboard__leave-value">
              {formatCurrency(leaveProvisions.totalAnnualLeave)}
            </span>
          </div>
          <div className="compliance-dashboard__leave-item">
            <span className="compliance-dashboard__leave-label">Long Service Leave</span>
            <span className="compliance-dashboard__leave-value">
              {formatCurrency(leaveProvisions.totalLongServiceLeave)}
            </span>
          </div>
        </div>
        {leaveProvisions.employees.length > 0 && (
          <div className="compliance-dashboard__table">
            <div className="compliance-dashboard__table-header">
              <span>Employee</span>
              <span>Annual</span>
              <span>LSL</span>
            </div>
            {leaveProvisions.employees.map((emp) => (
              <div key={emp.employeeId} className="compliance-dashboard__table-row">
                <span className="compliance-dashboard__emp-name">
                  {emp.employeeName}
                  <span className="compliance-dashboard__emp-detail">
                    {emp.yearsOfService.toFixed(1)} yrs &middot; {emp.state}
                  </span>
                </span>
                <span className="compliance-dashboard__emp-value">
                  {formatCurrency(emp.annualLeaveProvision)}
                </span>
                <span className="compliance-dashboard__emp-value">
                  {formatCurrency(emp.longServiceLeaveProvision)}
                  {emp.lslVested && (
                    <span className="compliance-dashboard__vested">vested</span>
                  )}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </SectionCard>
  );
}
